/**
 * Algolia Configuration
 * 
 * This configuration is now managed through Shopify theme settings.
 * Configure your Algolia settings in the theme customizer under "Search" section.
 * 
 * The configuration is automatically generated from theme settings and
 * can be overridden by setting window.ALGOLIA_CONFIG_OVERRIDE if needed.
 */

// Function to get theme settings from the global Shopify object
function getThemeSettings() {
  // Try to get settings from the global Shopify object
  // @ts-ignore
  if (typeof window.Shopify !== 'undefined' && window.Shopify.theme) {
    // @ts-ignore
    return window.Shopify.theme.settings || {};
  }
  
  // Fallback: try to get from meta tags (if theme provides them)
  const settingsMeta = document.querySelector('meta[name="theme-settings"]');
  if (settingsMeta) {
    try {
      // @ts-ignore
      return JSON.parse(settingsMeta.content);
    } catch (e) {
      console.warn('Could not parse theme settings from meta tag');
    }
  }
  
  // Return empty object if no settings found
  return {};
}

// Function to create Algolia configuration from theme settings
function createAlgoliaConfig() {
  const settings = getThemeSettings();
  
  // Check if Algolia search is enabled
  if (!settings.enable_predictive_search) {
    return null;
  }
  
  // Create configuration object from theme settings
  const config = {
    // Algolia Application Settings (from theme settings)
    appId: settings.algolia_app_id || '',
    apiKey: settings.algolia_search_api_key || '',
    indexName: settings.algolia_index_name || '',
    querySuggestionsIndexName: settings.algolia_query_suggestions_index_name || '',
    productsSearchIndexName: `${settings.algolia_index_name}products`,
    blogSearchIndexName:`${settings.algolia_index_name}articles`,
    recipeSearchIndexName: `${settings.algolia_index_name}articles`,
    pageSearchIndexName: `${settings.algolia_index_name}pages`,
    
    // Search Configuration (defaults - can be overridden by block settings)
    maxProductSuggestions: settings.max_product_suggestions || 4,
    highlightPreTag: '__aa-highlight__',
    highlightPostTag: '__/aa-highlight__',
    
    // UI Configuration (defaults - can be overridden by block settings)
    openOnFocus: true,
    insights: true,
    
    // Customization Options (from theme settings)
    placeholder: settings.search_placeholder_text || 'Search...',
    noResultsText: settings.search_empty_state_message || 'No suggestions found',
    viewAllProductsText: settings.search_footer_link_text || 'View all products',
    
    // Feature Flags (from theme settings)
    enableAnalytics: settings.algolia_enable_analytics !== false,
    enablePersonalization: false, // Not configurable via theme settings yet
    enableVoiceSearch: false, // Not configurable via theme settings yet
    
    // Performance Settings (defaults - can be overridden by block settings)
    debounceTime: 200,
    maxPopularKeywordsSuggestions: settings.popular_keywords || 0,
    
    // Accessibility Settings (defaults - can be overridden by block settings)
    announceResults: true,
    keyboardNavigation: true,
    focusManagement: true, // Always enabled for accessibility
  };
  
  return config;
}

// Initialize Algolia configuration
// @ts-ignore
if (typeof window.ALGOLIA_CONFIG === 'undefined') {
// @ts-ignore
window.ALGOLIA_CONFIG = (function() {
  // Check for override configuration first
  // @ts-ignore
  if (typeof window.ALGOLIA_CONFIG_OVERRIDE !== 'undefined') {
    console.log('Using Algolia configuration override');
    // @ts-ignore
    return window.ALGOLIA_CONFIG_OVERRIDE;
  }
  
  // Create configuration from theme settings
  const config = createAlgoliaConfig();
  
  if (config) {
    console.log('Algolia configuration loaded from theme settings');
    return config;
  } else {
    console.warn('Algolia search is disabled or not properly configured in theme settings');
    return null;
  }
})();
}


// Validation function to check if configuration is complete
// @ts-ignore
window['validateAlgoliaConfig'] = function() {
  // @ts-ignore
  const config = window.ALGOLIA_CONFIG;
  
  // Check if Algolia is disabled
  if (!config) {
    console.log('Algolia search is disabled in theme settings');
    return false;
  }
  
  const required = ['appId', 'apiKey', 'indexName'];
  
  for (const field of required) {
    if (!config[field] || config[field].trim() === '' || config[field].includes('YOUR_')) {
      console.error(`Algolia Configuration Error: ${field} is not properly configured in theme settings`);
      return false;
    }
  }
  
  console.log('Algolia configuration is valid');
  return true;
};

// Function to check if Algolia is enabled and properly configured
// @ts-ignore
window['isAlgoliaEnabled'] = function() {
  // @ts-ignore
  const config = window.ALGOLIA_CONFIG;
  return config !== null && config !== undefined;
};

// Initialize configuration validation
document.addEventListener('DOMContentLoaded', () => {
  // @ts-ignore
  if (window.ALGOLIA_CONFIG) {
    // @ts-ignore
    window['validateAlgoliaConfig']();
  }
});

